export default {"src":"/_next/static/media/sky.79ce2a29.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};